module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "material-icons action-icon",
    on: {
      "click": _vm.showEditModal
    }
  }, [_vm._v("\n  mode_edit\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2e9ae2c0!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/EditCategoryTrigger.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-2e9ae2c0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/EditCategoryTrigger.vue
// module chunks = 0